import { ReactElement } from "react";
import { isTMessage, TMessage } from "../i18n/tt";
import { useTranslation } from "../stores/RootStoreContext";
import { Markdown } from "../text/Markdown";
import { Popover } from "./Popover";
import { Icon, IconColor } from "./Icon";
import { VBox } from "./Box";
import { IconName } from "./iconMapping";

export type InfoButtonProps = {
  infoText?: ReactElement | TMessage | string | number;
  color?: IconColor;
  icon?: IconName;
  disableMaxWidth?: boolean;
};

export function InfoButton({ infoText, icon, color, disableMaxWidth }: InfoButtonProps) {
  const { t } = useTranslation();

  const renderInfoText = () => {
    if (isTMessage(infoText)) {
      return <Markdown value={t(infoText)} disableLastMargin />;
    }
    return infoText;
  };

  return infoText ? (
    <Popover
      button={({ toggleOpen, setReference }) => (
        <button
          ref={setReference}
          onClick={toggleOpen}
          className={"tw-inline-flex tw-align-text-bottom"}
        >
          <Icon name={icon ?? "info"} color={color ?? "info"} />
        </button>
      )}
      content={<VBox maxWidth={disableMaxWidth ? undefined : "prose"}>{renderInfoText()}</VBox>}
    />
  ) : null;
}
